export const mapActiveItem = (activeItem) => {
  let item = { ...activeItem };
  item.selectedCategory = {
    serviceCategoryName: activeItem.vendorServiceCategoryName,
    serviceCategoryId: activeItem.vendorServiceCategoryId,
  };
  item.selectedAvailability = {
    lookupItemName: activeItem.serviceAvailabilityName,
    lookupItemId: activeItem.serviceAvailabilityId,
  };
  item.vendorServiceTagIds = activeItem.vendorServiceTags.map(
    (item) => item.tagId
  );
  item.selectedTags = activeItem.vendorServiceTags.map((tagItem) => ({
    lookupItemName: tagItem.tagName,
    lookupItemId: tagItem.tagId,
  }));
  return item;
};

export const mapStateToSaveDto = (state) => {
  let item = {};
  item.serviceType = state.serviceType;
  item.serviceAvailabilityId = state.serviceAvailabilityId;
  item.description = state.description;
  item.vendorServiceCategoryId = state.vendorServiceCategoryId;
  item.serviceSettingId = state.serviceSettingId;
  item.vendorServiceTagIds = state.vendorServiceTagIds;
  return item;
};
